import React from "react";
import { Check, Package, Truck, Home, Clock, Ban } from "lucide-react";

const STEPS = [
  { key: "confirmed", label: "Confirmed", icon: Check },
  { key: "packed", label: "Packed", icon: Package },
  { key: "shipped", label: "Shipped", icon: Truck },
  { key: "out_for_delivery", label: "Out for delivery", icon: Truck },
  { key: "delivered", label: "Delivered", icon: Home },
];

export function OrderStatusTracker({ status, statusHistory = [], compact = false }) {
  if (status === "cancelled") {
    return (
      <div className="flex items-center gap-3 p-4 bg-[#b33939]/5 border border-[#b33939]/30" data-testid="order-tracker-cancelled">
        <Ban size={20} className="text-[#b33939]" />
        <div>
          <div className="font-medium text-[#b33939]">Order Cancelled</div>
          <div className="text-xs text-[#7c7273]">Please contact support if this is unexpected.</div>
        </div>
      </div>
    );
  }
  if (status === "pending") {
    return (
      <div className="flex items-center gap-3 p-4 bg-[#c9a34a]/10 border border-[#c9a34a]/40" data-testid="order-tracker-pending">
        <Clock size={20} className="text-[#7a1e2b]" />
        <div>
          <div className="font-medium text-[#7a1e2b]">Awaiting Payment</div>
          <div className="text-xs text-[#7c7273]">Your order is confirmed once payment is complete.</div>
        </div>
      </div>
    );
  }

  const currentIdx = STEPS.findIndex((s) => s.key === status);
  const historyMap = new Map((statusHistory || []).map((h) => [h.status, h.at]));

  return (
    <div data-testid="order-tracker">
      <div className={`grid ${compact ? "grid-cols-5" : "grid-cols-5 gap-1"} items-start`}>
        {STEPS.map((step, i) => {
          const done = i <= currentIdx;
          const active = i === currentIdx;
          const Icon = step.icon;
          return (
            <div key={step.key} className="flex flex-col items-center relative">
              {i > 0 && (
                <div className={`absolute right-1/2 top-4 h-0.5 w-full -z-0 ${i <= currentIdx ? "bg-[#7a1e2b]" : "bg-[#e8e4db]"}`} />
              )}
              <div
                className={`relative z-10 w-8 h-8 rounded-full flex items-center justify-center border-2 transition-colors ${
                  done ? "bg-[#7a1e2b] border-[#7a1e2b] text-white" : "bg-white border-[#e8e4db] text-[#7c7273]"
                } ${active ? "ring-4 ring-[#7a1e2b]/20" : ""}`}
                data-testid={`tracker-step-${step.key}`}
              >
                <Icon size={14} />
              </div>
              <div className={`text-[10px] mt-2 text-center uppercase tracking-widest ${done ? "text-[#2b1b1c] font-medium" : "text-[#7c7273]"}`}>
                {step.label}
              </div>
              {historyMap.get(step.key) && !compact && (
                <div className="text-[10px] text-[#7c7273] mt-0.5">
                  {new Date(historyMap.get(step.key)).toLocaleDateString()}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
